/**
 * @desc ToB客户信息-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  params: API.basics.businessCustomer.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
